import { DATA_INTRO_TO } from "./Introduction/401DataIntroTO";
import { DATA_BENEFITS_TO_1 } from "./Introduction/402DataBenefitsTO_1";
import { DATA_BENEFITS_TO_2 } from "./Introduction/403DataBenefitsTO_2";
import { DATA_CHARACTERS_TO } from "./Introduction/404DataCharactersTO_4";
import { DATA_TO_DEMO_1 } from "./TO_DEMO/405DataTODemo_1";
import { DATA_TO_DEMO_2 } from "./TO_DEMO/406DataTODemo_2";
import { DATA_TO_DEMO_3 } from "./TO_DEMO/407DataTODemo_3";
import { DATA_TO_DEMO_4 } from "./TO_DEMO/408DataTODemo_4";
import DATA_TO_DEMO_END from "./TO_DEMO/409DataTODemo_End";

export const TO_WORKFLOW = [
  { page: 401, type: "intro-template" as TemplateType, data: DATA_INTRO_TO },
  {
    page: 402,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_TO_1,
  },
  {
    page: 403,
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_TO_2,
  },
  {
    page: 404,
    type: "characters-template" as TemplateType,
    data: DATA_CHARACTERS_TO,
  },
  {
    page: 405,
    type: "journey-two-template" as TemplateType,
    data: DATA_TO_DEMO_1,
  },
  {
    page: 406,
    type: "journey-two-template" as TemplateType,
    data: DATA_TO_DEMO_2,
  },
  {
    page: 407,
    type: "journey-two-template" as TemplateType,
    data: DATA_TO_DEMO_3,
  },
  {
    page: 408,
    type: "journey-two-template" as TemplateType,
    data: DATA_TO_DEMO_4,
  },
  {
    page: 409,
    type: "end-template" as TemplateType,
    data: DATA_TO_DEMO_END,
  },
];
